// import components
import PatientSearch from './components/PatientSearch';
import PatientInfo from './components/PatientInfo';
import PatientTreatments from './components/PatientTreatments';
import PatientPrescriptions from './components/prescriptions/PatientPrescriptions';
import StyledTabs from 'components/shared/StyledTabs';
import TabPanel from 'components/shared/TabPanel';
import { styled, Tab, Tabs } from '@mui/material';

// import constants
import { StyledBoxFlexAlignCenterSpaceBetween } from 'components/shared/Box/Box.styles';
import { StyledStickyPaper } from 'components/shared/Paper/StyledStickyPaper';
import {
  StyledBottomBox,
  StyledPatientSelectorBox,
  StyledCareReceiversHomeBox,
  StyledTopBox
} from './CareReceiversHome.styles';

// import external libraries
import { useTranslation } from 'react-i18next';

// import hooks
import { useCareReceiversHome, TabType } from './CareReceiversHome.hooks';

const StyledTabPanel = styled(TabPanel)`
  min-height: 100%;
`;

const CareReceiversHome = () => {
  const { t } = useTranslation('common', { keyPrefix: 'careReceiversHome' });

  const {
    subPage,
    onTabChanged,
    selectedPatient,
    onSelectPatient,
    patientDetails,
    isLoadingDetails,
    prescriptions,
    isLoadingPrescriptions
  } = useCareReceiversHome();

  return (
    <StyledCareReceiversHomeBox>
      <StyledPatientSelectorBox>
        <PatientSearch value={selectedPatient} onSelected={onSelectPatient} />
      </StyledPatientSelectorBox>

      <StyledTopBox>
        <StyledTabs>
          <StyledStickyPaper sx={{ mx: 0 }} square>
            <StyledBoxFlexAlignCenterSpaceBetween>
              <Tabs
                value={subPage}
                indicatorColor="primary"
                textColor="primary"
                onChange={onTabChanged}
                className="tabs"
              >
                <Tab
                  label={t('tabs.patientInfo')}
                  value={TabType.PATIENT_INFO}
                />
                <Tab label={t('tabs.treatments')} value={TabType.TREATMENTS} />
                <Tab
                  label={t('tabs.prescriptions')}
                  value={TabType.PRESCRIPTIONS}
                />
              </Tabs>
            </StyledBoxFlexAlignCenterSpaceBetween>
          </StyledStickyPaper>
        </StyledTabs>
      </StyledTopBox>

      <StyledBottomBox>
        <StyledTabPanel
          value={TabType.PATIENT_INFO}
          activePage={subPage}
          title={t('tabs.patientInfo')}
        >
          {patientDetails && (
            <PatientInfo
              patient={patientDetails}
              isLoading={isLoadingDetails}
            />
          )}
        </StyledTabPanel>

        <StyledTabPanel
          value={TabType.TREATMENTS}
          activePage={subPage}
          title={t('tabs.treatments')}
        >
          {patientDetails && (
            <PatientTreatments
              patient={patientDetails}
              isLoading={isLoadingDetails}
            />
          )}
        </StyledTabPanel>

        <StyledTabPanel
          value={TabType.PRESCRIPTIONS}
          activePage={subPage}
          title={t('tabs.prescriptions')}
        >
          {selectedPatient && (
            <PatientPrescriptions
              prescriptions={prescriptions}
              isLoading={isLoadingPrescriptions}
            />
          )}
        </StyledTabPanel>
      </StyledBottomBox>
    </StyledCareReceiversHomeBox>
  );
};

export default CareReceiversHome;
